import { Suspense, useState } from "react";
import { Badge, BadgeProps, IconButton } from "@mui/material";
import { Icon, iconNotification } from "theme/icons";
import NotificationMenu from "./NotificationMenu";
import { useRecoilValueLoadable } from "recoil";
import { broadcastsSelector } from "state/messageState";
import { Broadcast } from "types/broadcast";

const useNotification = () => {
  const broadcastsLoadable = useRecoilValueLoadable(broadcastsSelector);
  let broadcasts = [] as Broadcast[];

  let badgeColor: BadgeProps["color"] = "default"; // Default badge color

  switch (broadcastsLoadable.state) {
    case "loading":
      badgeColor = "warning";
      break;
    case "hasValue":
      broadcasts = broadcastsLoadable.contents;
      badgeColor = "error"; // Use error color when there are unread conversations
      break;
    default:
      badgeColor = "default";
      break;
  }

  const notifications = broadcasts || [];

  return { notifications, badgeColor };
};

const Notification = () => {
  const { notifications, badgeColor } = useNotification();
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  console.log("Notifications:", notifications);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  // We dont want to show the notification icon if there are no notifications (system messages)
  if (notifications.length === 0) return null;

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen} data-testid="notification-button">
        <Badge badgeContent={notifications.length} color={badgeColor}>
          <Icon name={iconNotification} />
        </Badge>
      </IconButton>
      <NotificationMenu anchorElement={anchorElement} onClose={handleClose} notifications={notifications} />
    </>
  );
};

// Suspense wrapper needed for recoil selectors to work properly with lazy loading
const NotificationWrapper = () => {
  return (
    <Suspense>
      <Notification />
    </Suspense>
  );
};

export default NotificationWrapper;
